import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  selectedBranch: "",
  selectedApplicationNumber: "",
  remarkErrorClear:true,
};
const AdditionalFeeReducer = createSlice({
  name: "AdditionalFee",
  initialState: initialState,
  reducers: {
    updateSelectedBranch(state, action) {
      state.selectedBranch = action.payload;
    },
    updateSelectedApplicatioNumber(state, action) {
      state.selectedApplicationNumber = action.payload;
    },
    updateRemarkClear(state, action) {
      state.remarkErrorClear = action.payload;
    },
  },
});
export const AdditionalFeeReducerAction = AdditionalFeeReducer.actions;
export default AdditionalFeeReducer.reducer;
